import vClickOutside from "v-click-outside";

export default {
	props: {
		value: [String, Number, Object],

		/** string[] | object[] */
		items: Array,

		/*
		 * if `items` is object[], a `label` prop must be provided.
		 * object[label] will be displayed.
		 */
		label: String,

		/**	value used for data-test-id */
		testId: {
			type: String,
			required: true,
		},

		placeholder: {
			type: String,
			default: "",
		},
	},

	// enable v-model for <base-dropdown> component
	model: { event: "change" },

	directives: { clickOutside: vClickOutside.directive },

	data() {
		return { isOpen: false };
	},

	methods: {
		select,
		openMenu,
		hideMenu,
	},
};

function select(item) {
	this.$emit("change", item);
	this.hideMenu();
}

function openMenu() {
	this.isOpen = true;
}

function hideMenu() {
	this.isOpen = false;
}
